<template>
  <div id="stores">
    <div class="header flex-between">
      <div class="header-text">
        <h1>手工分组</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="searchList"
          >{{ searchBtnText }}</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="iconfont icon-chuangjian1"
          @click="goManualDialog(1)"
          >{{ insertBtnText }}</el-button
        >
        <el-button
          v-if="jurisdiction.copy"
          icon="el-icon-edit-outline"
          @click="goManualDialog(2)"
          >{{ copeBtnText }}</el-button
        >
        <el-button
          v-if="jurisdiction.modify"
          icon="iconfont icon-xiugai1"
          @click="goManualDialog(3)"
          >{{ modifyBtnText }}</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="iconfont icon-a-shanchu11"
          @click="deleteBtn"
          >{{ deleteBtnText }}</el-button
        >
        <el-button v-if="jurisdiction.enable" @click="enableChange">{{
          enableBtnText
        }}</el-button>
        <el-button v-if="jurisdiction.disable" @click="disableChange">{{
          disableBtnText
        }}</el-button>
        <el-button
          v-if="jurisdiction.look"
          icon="iconfont icon-chakan1"
          @click="goLookDialog"
          >{{ lookBtnText }}</el-button
        >
      </div>
    </div>
    <el-card shadow="never">
      <div class="searchform">
        <el-form size="small" label-width="9.375rem">
          <el-row>
            <el-col :span="8">
              <el-form-item label="分组名称">
                <el-input v-model="config.custGrpName" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="分组类型">
                <el-select style="width: 100%" v-model="fenZhuOptionsSelect">
                  <el-option
                    v-for="item in fenZhuOptions"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="状态">
                <el-select style="width: 100%" v-model="config.state">
                  <el-option label="所有" value=""></el-option>
                  <el-option label="已启用" value="0"></el-option>
                  <el-option label="未启用" value="1"></el-option>
                  <el-option label="已无效" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="创建日期从">
                <el-date-picker
                  v-model="config.createDateStart"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
                至
                <el-date-picker
                  v-model="config.createDateEnd"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never" class="centercard">
      <el-table
        size="small"
        class="table-style"
        height="600px"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
          fontSize: '.875rem',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        v-el-table-infinite-scroll="load"
        v-loading="loading"
        infinite-scroll-disabled="onLoading"
        @selection-change="handleSelectionChange"
        @select="handleSelectionCheck"
      >
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column label="分组名称">
          <template slot-scope="scope">
            <div
              v-if="jurisdiction.look"
              style="text-decoration: underline; color: skyblue"
              @click="goLookDialog1(scope.row.customerGrpID)"
            >
              {{ scope.row.custGrpName }}
            </div>
            <div v-else style="text-decoration: underline; color: skyblue">
              {{ scope.row.custGrpName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="分组类型">
          <template slot-scope="scope">
            {{ scope.row.grpKind == 0 ? "公共分组" : "个人分组" }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="状态">
          <template slot-scope="scope">
            {{
              scope.row.state == 0
                ? "已启用"
                : scope.row.state == 1
                ? "未启用"
                : "已无效"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" label="创建人">
        </el-table-column>
        <el-table-column prop="createTime" label="创建日期">
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormats }}
          </template>
        </el-table-column>
        <el-table-column prop="updateUserName" label="最后修改人">
        </el-table-column>
        <el-table-column prop="updateTime" label="最后修改日期">
          <template slot-scope="scope">
            <div v-if="scope.row.updateTime">
              {{ scope.row.updateTime | dateFormats }}
            </div>
            <div v-else></div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <manual-Dialog ref="manualDialogRef"></manual-Dialog>
    <lookDialog ref="lookDialogRef"></lookDialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import manualDialog from "./manualDialog.vue";
import lookDialog from "./lookDialog.vue";
// import { dateTimes } from "@/utils/auth";
import {
  groundPageApi,
  lookGroundApi,
  enableApi,
  disableApi,
  deleteApi,
} from "@/api/marketing";
export default {
  name: "centre",
  components: {
    manualDialog,
    lookDialog,
  },
  data() {
    return {
      jurisdiction: {
        search: false,
        create: false,
        copy: false,
        modify: false,
        delete: false,
        enable: false,
        disable: false,
        look: false,
      },
      loading: false,
      salesVisible: false,
      radio: "",
      queryInfoTable: {}, //列表请求数据
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      dialogData: [], //弹窗数据
      lookGroundList: [], // 查看组信息
      fenZhuOptionsSelect: "", //分组
      SelectChang: {}, //选择的数据
      tableData: [],
      config: {
        pageNo: 1,
        pageSize: 50,
        pagesTotal: 0,
        total: 0,
        custGrpName: "",
        state: "",
        createDateStart: undefined,
        createDateEnd: undefined,
        grpMode: 2, // 手工分组
      },
      fenZhuOptions: [
        {
          value: "",
          label: "所有",
        },
        {
          value: 0,
          label: "公共分组",
        },
        {
          value: 1,
          label: "个人分组",
        },
      ],
    };
  },
  created() {
    this.tableList();
    let ManualGroup = JSON.parse(localStorage.getItem("ManualGroup"));
    for (let i = 0; i < ManualGroup.length; i++) {
      if (ManualGroup[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (ManualGroup[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }
      if (ManualGroup[i].menuName == "复制") {
        this.jurisdiction.copy = true;
        continue;
      }
      if (ManualGroup[i].menuName == "修改") {
        this.jurisdiction.modify = true;
        continue;
      }
      if (ManualGroup[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
      if (ManualGroup[i].menuName == "启用") {
        this.jurisdiction.enable = true;
        continue;
      }
      if (ManualGroup[i].menuName == "禁用") {
        this.jurisdiction.disable = true;
        continue;
      }
      if (ManualGroup[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
    }
    console.log(ManualGroup);
  },
  computed: {
    isMore() {
      return this.config.pageNo >= this.config.pagesTotal;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    ...mapState([
      "searchBtnText",
      "insertBtnText",
      "copeBtnText",
      "modifyBtnText",
      "deleteBtnText",
      "enableBtnText",
      "disableBtnText",
      "examineBtnText",
      "lookBtnText",
    ]),
  },
  methods: {
    getCurrentRow(row) {
      // 获取选中数据   row表示选中这一行的数据，可以从里面提取所需要的值
      this.templateSelection = row;
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.SelectChang = e[e.length - 1];
      } else {
        this.SelectChang = {};
      }
      // console.log(e)
    },
    handleSelectionCheck(selection, row) {
      this.$refs.multipleTable.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.SelectChang = row;
        this.$refs.multipleTable.toggleRowSelection(row, true);
        // this.lookGround();
      }
      // console.log(row);
    },
    // 创建/修改/复制弹窗
    goManualDialog(index) {
      if (index == 1) {
        this.$refs.manualDialogRef.title = "会员分组-手工分组-创建";
        this.$refs.manualDialogRef.open = true;
        this.$refs.manualDialogRef.id = index;
      } else if (index == 2) {
        if (Object.keys(this.SelectChang) < 2) {
          this.$message({
            message: "请选择数据!",
            type: "warning",
          });
        } else {
          lookGroundApi({
            customerGrpID: this.SelectChang.customerGrpID,
          }).then((res) => {
            if (res.success) {
              this.lookGroundList = res.data.grpinfo;
              this.$refs.manualDialogRef.title = "会员分组-手工分组-复制";
              this.$refs.manualDialogRef.form = this.lookGroundList;
              this.$refs.manualDialogRef.open = true;
              this.$refs.manualDialogRef.id = index;
            }
          });
        }
      } else {
        if (Object.keys(this.SelectChang) < 2) {
          this.$message({
            message: "请选择数据!",
            type: "warning",
          });
        } else {
          this.$refs.manualDialogRef.title = "会员分组-条件分组-修改";
          this.$refs.manualDialogRef.open = true;
          this.$refs.manualDialogRef.id = index;
          lookGroundApi({
            customerGrpID: this.SelectChang.customerGrpID,
          }).then((res) => {
            if (res.success) {
              this.lookGroundList = res.data.grpinfo;
              this.$refs.manualDialogRef.form = this.lookGroundList;
            }
          });
        }
      }
    },
    // 查看
    goLookDialog() {
      if (Object.keys(this.SelectChang) < 2) {
        this.$message({
          message: "请选择数据!",
          type: "warning",
        });
      } else {
        lookGroundApi({
          customerGrpID: this.SelectChang.customerGrpID,
        }).then((res) => {
          if (res.success) {
            this.lookGroundList = res.data.grpinfo;
            this.$refs.lookDialogRef.lookOpen = true;
            this.$refs.lookDialogRef.tableData = [];
            this.$refs.lookDialogRef.config.pageNo = 1;

            this.$refs.lookDialogRef.searchList();
            this.$refs.lookDialogRef.leftForm = this.lookGroundList;
          }
        });
      }
    },
    goLookDialog1(index) {
      console.log(index);
      lookGroundApi({ customerGrpID: index }).then((res) => {
        if (res.success) {
          this.lookGroundList = res.data.grpinfo;
          this.$refs.lookDialogRef.lookOpen = true;
          this.$refs.lookDialogRef.tableData = [];
          this.$refs.lookDialogRef.config.pageNo = 1;

          this.$refs.lookDialogRef.searchList();
          this.$refs.lookDialogRef.leftForm = this.lookGroundList;
        }
      });
    },
    // 列表
    tableList() {
      let queryInfoTable = {
        pageNo: this.config.pageNo,
        pageSize: this.config.pageSize,
        custGrpName: this.config.custGrpName,
        state: this.config.state,
        grpKind: this.fenZhuOptionsSelect,
        createDateStart: this.config.createDateStart,
        createDateEnd: this.config.createDateEnd,
        grpMode: this.config.grpMode,
      };
      groundPageApi(require("qs").stringify(queryInfoTable)).then((res) => {
        if (res.message == "success") {
          //  console.log(res)
          if (this.config.pageNo == 1) {
            this.tableData = res.data.list;
          } else {
            this.tableData = this.tableData.concat(res.data.list);
          }
          this.config.pageSize = res.data.pageSize;
          this.loading = false;
        }
      });
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.config.pageNo += 1;
        this.tableList();
      }, 500);
    },
    searchList() {
      this.tableData = [];
      this.config.total = 0;
      this.config.pageNo = 1;
      this.tableList();
    },
    // 启用
    enableChange() {
      if (Object.keys(this.SelectChang) < 2) {
        this.$message({
          message: "请选择数据",
          type: "warning",
        });
      } else {
        this.$confirm("是否启用？", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        })
          .then(() => {
            let enableA = {
              customerGrpID: this.SelectChang.customerGrpID,
            };
            enableApi(require("qs").stringify(enableA)).then((res) => {
              if (res.message) {
                this.$message.success("已启用");
                this.tableData = [];
                this.config.total = 0;
                this.config.pageNo = 1;
                this.tableList();
              } else {
                this.$message.error("当前无效状态，不能修改!");
              }
            });
          })
          .catch(() => {
            this.$message.info("取消启用！");
          });
      }
    },
    // 禁用
    disableChange() {
      if (Object.keys(this.SelectChang) < 2) {
        this.$message({
          message: "请选择数据",
          type: "warning",
        });
      } else {
        this.$confirm("是否禁用?", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        })
          .then(() => {
            let enableB = {
              customerGrpID: this.SelectChang.customerGrpID,
            };
            disableApi(enableB).then((res) => {
              if (res.message) {
                this.$message.success("已禁用");
                this.tableData = [];
                this.config.total = 0;
                this.config.pageNo = 1;
                this.tableList();
              }
            });
          })
          .catch(() => {
            this.$message.info("取消禁用！");
          });
      }
    },
    //delete
    deleteBtn() {
      if (Object.keys(this.SelectChang) < 2) {
        this.$message({
          showClose: true,
          message: "请选择数据,再删除!",
          type: "warning",
        });
      } else {
        this.$confirm("是否删除?", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        })
          .then(() => {
            deleteApi({ customerGrpID: this.SelectChang.customerGrpID }).then(
              (res) => {
                if (res.message) {
                  this.$message.success("删除成功!");
                  this.tableData = [];
                  this.config.total = 0;
                  this.config.pageNo = 1;
                  this.tableList();
                }
              }
            );
          })
          .catch(() => {
            this.$message.info("取消删除！");
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#stores {
  // height: 84.375rem;
  height: 100%;
}
.header {
  .header-text {
    height: 3.125rem;
    margin-top: 1.25rem;
    color: #76734f;
  }
}
.searchform {
  margin-top: 1.25rem;
}
.centercard {
  margin-top: 0.625rem;
}
.card-pagination {
  margin-top: 1.25rem;
  text-align: right;
}
.push-button {
  background-color: #e9e7d3;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 0.4375rem;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0 !important;
}

::v-deep {
  // 改变table里的按钮图标大小
  .table-button {
    .el-button {
      border: 0;
    }
    .iconfont {
      font-size: 0.875rem;
    }
  }
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  // 创建弹框样式
  .alteration {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 0.875rem;
      font-weight: 700;
      color: #6c6937;
    }

    .el-dialog__footer {
      height: 3.75rem;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
  // 添加会员弹窗
  // 创建弹窗样式
  .sales {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 0.875rem;
      font-weight: 700;
      color: #6c6937;
    }

    .el-dialog__footer {
      height: 3.75rem;
      background-color: #f2f2f2;
    }
  }
  .el-textarea__inner {
    // 取消拉伸样式
    resize: none;
  }
}
</style>
